<template>
  <div class="ts-space-y-3">
    <div class="row">
      <div class="col-md-12">
        <label class="ts-mb-0 required ts-font-robot">{{
          $t('siteProfile.siteName')
        }}</label>
        <input
          v-model="model.site_name"
          type="text"
          class="form-control"
          placeholder="Input site name. ex: Phnom Penh"
        />
        <div class="validate" v-if="errors.has('site_name')">
          {{ errors.first('site_name') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-mb-0 ts-font-robot">{{
          $t('siteProfile.siteOwner')
        }}</label>
        <a-select
          v-model="model.site_owner"
          :options="owners"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          class="ts-w-full"
          placeholder="Select who is main response"
        ></a-select>
        <div class="validate" v-if="errors.has('site_owner')">
          {{ errors.first('site_owner') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-mb-0 ts-font-robot">{{
          $t('siteProfile.member')
        }}</label>
        <a-select
          v-model="model.site_member"
          mode="multiple"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          :options="owners"
          class="ts-w-full"
          placeholder="Select who will be involve"
        ></a-select>
        <div class="validate" v-if="errors.has('site_member')">
          {{ errors.first('site_member') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-mb-0 ts-font-robot">{{
          $t('siteProfile.location')
        }}</label>
        <Input
          v-model="model.geolocation"
          prefix="ios-calculator"
          placeholder="11.562108,104.888535"
        />
        <div class="validate" v-if="errors.has('geolocation')">
          {{ errors.first('geolocation') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-mb-0 ts-font-robot">{{
          $t('siteProfile.remark')
        }}</label>
        <textarea
          v-model="model.remarks"
          rows="3"
          class="form-control"
          placeholder="Note something here"
        ></textarea>
        <div class="validate" v-if="errors.has('remarks')">
          {{ errors.first('remarks') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div
        class="col-md-12 ts-flex ts-items-center ts-justify-end ts-space-x-3"
      >
        <ts-button @click.prevent="$emit('cancel')">
          {{ $t('cancel') }}</ts-button
        >
        <ts-button color="primary" @click.prevent="onUpdate">
          {{ $t('update') }}</ts-button
        >
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  props: ['edit_data'],
  data() {
    return {
      errors: new Errors(),
      loading: false,
      owners: [],
      model: {
        id: '',
        site_name: '',
        site_owner: '',
        site_member: [],
        remarks: ''
      }
    }
  },
  created() {
    this.fetchModel()
  },
  methods: {
    ...mapActions('projectMgt/siteProfile', ['formViewModel', 'update']),
    fetchModel() {
      this.loading = true
      this.formViewModel()
        .then(response => {
          this.owners = response.data.owner.map(el => ({
            value: el.user_id,
            label: el.employee_name_kh + '|' + el.employee_name_en
          }))
          this.setEditData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    onUpdate() {
      this.loading = true
      this.errors = new Errors()
      this.update({
        id: this.model.id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setEditData() {
      this.model.id = this.edit_data.id
      this.model.site_name = this.edit_data.site_name
      this.model.site_owner = this.edit_data.site_owner
      this.model.geolocation = this.edit_data.geolocation
      if (this.edit_data.site_member) {
        this.model.site_member = JSON.parse(this.edit_data.site_member).map(
          el => el.user_id
        )
      }
      this.model.remarks = this.edit_data.remarks
    }
  }
}
</script>
